import { gql } from 'apollo-angular';

export const GET_SAVED_VEHICLES = gql`
  query GetSavedVehicles {
    savedVehicles {
      id
      vehicleType
      licensePlate
      vin
      vehicleId
      modificationId
      year
      selected
      details {
        manufacturer {
          id
          name
          shortName
        }
        model {
          id
          name
        }
        modification {
          id
          name
        }
        beginYearMonth
        endYearMonth
        period
        images {
          url50
          url100
          url200
          url400
          url800
        }
        kbaNumbers
        driveType {
          id
          name
        }
        bodyStyle {
          id
          name
        }
        valves
        fuelMixtureFormationType {
          id
          name
        }
        fuelType {
          id
          name
        }
        engineType {
          id
          name
        }
        powerHp
        powerKw
        cylinders
        capacity {
          cc
          liters
        }
        engines {
          id
          code
        }
      }
    }
  }
`;
